import { IPaginationResourceShort } from '../../../props/general';
import { ICompanyApprovalResourceProps, ICompanyApprovalResourceShortProps } from '../../../props/users/companies/approval';
import Request from './../../request';

const CompanyApprovalService = {
  retrieve: async (companyId: string, qs?: string): Promise<{data: ICompanyApprovalResourceShortProps[], pagination: IPaginationResourceShort}> => {
    try {
      const results = await Request.get(`/api/companies/${companyId}/approvals?${qs}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (companyId: string, data: FormData): Promise<ICompanyApprovalResourceProps> => {
    try {
      const results = await Request.post(`/api/companies/${companyId}/approvals`, data);
      return results;
    } catch (e) {
      throw e;
    }
  }
};

export default CompanyApprovalService;
